//全局图片保存计时器
let NewTimeEvent = 0;
// 图片保存调用方法
// 一、vant特有上传
// 1、import { longPress } from "../../../common/js/myglobal";
// 2、vant上传组件设置事件代理@click-preview = "longPressAgent"
// 3、method编写longPressAgent(){
//       longPress();
//     }
// 二、普通调用
// 1、import { longPress } from "../../../common/js/myglobal";
// 2、需要保存功能的图片定义私有属性isImgLoad="true"
// 3、updated数据更新时就进行方法longPress调用
// 三、options扩展内部方法预留，允许函数回调
//长按事件
function longPress(options) {
    $("img[isImgLoad=true]").unbind("touchstart").unbind("touchend").unbind("touchmove").on("touchstart", function (e) {
        let $this = $(this);
        //预留options方便扩展
        options = options || "";
        NewTimeEvent = setTimeout(() => {
            //默认长按保存图片，但同时允许禁用保存图片功能，直接长按回调callback函数
            if(!options.callback){
                let src = $this.attr("src");
                saveImg(src);
            }else{
                //如果有回调函数就直接回调
                options.callback();
            }
        }, 500); //这里设置定时器，定义长按500毫秒触发长按事件，时间可以自己改，个人感觉500毫秒非常合适
        return false;
        }).on("touchend", function () {
            clearTimeout(NewTimeEvent);
            NewTimeEvent = 0;
        }).on("touchmove", function () {
            clearTimeout(NewTimeEvent);
            NewTimeEvent = 0;
        });
}

function saveImg(url){
    try {
        let actions = {
            title:'操作',
            cancel:"取消",
            buttons:[{title:"保存到相册"}]
          };
          //图片下载地址
          let src = url;  
          //开始调用安卓plus
          plus.nativeUI.actionSheet(actions,function(e){  
            if(e.index==1){  
              //创建下载任务
              let newDownload = plus.downloader.createDownload(src,{method:"GET"},function(mydom,status){  
                  //下载完成的回调函数  
                  if (status == 200 ) {
                    //用gallery的save方法保存到相册
                    plus.gallery.save(mydom.filename,function(){
                        plus.io.resolveLocalFileSystemURL(mydom.filename,function(entry){  
                          //删除临时文件  
                          entry.remove();
                        });  
                        return alert('已保存至相册');  
                    });                       
                  }else{  
                      alert("对不起，保存失败，具体原因请查看：" + status);   
                  }    
              });  
              newDownload.start();//开始下载任务  
            }
          });
    }catch(e){
        console.log(e)
    }
}
export {
    longPress
}


// WEBPACK FOOTER //
// ./src/assets/js/common/saveimg.js